import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import './Footer.css';

export default function Footer() {
  const { data } = useData();
  const company = data?.company || {};
  const navigation = data?.navigation || [];
  const currentYear = new Date().getFullYear();

  const resourceLinks = [
    { label: 'Documentation', path: '#' },
    { label: 'API Reference', path: '#' },
    { label: 'Status Page', path: '#' },
    { label: 'Changelog', path: '#' },
  ];

  const legalLinks = [
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms of Service', path: '/terms' },
    { label: 'Careers', path: '/careers' },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <h4 className="footer__logo">IWX</h4>
            <p className="footer__tagline">{company.slogan}</p>
            <p className="footer__description">{company.description ? `${company.description.substring(0, 150)}...` : ''}</p>
            <div className="footer__social">
              {company.social && Object.entries(company.social).map(([platform, url]) => (
                <a key={platform} href={url} target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label={platform}>
                  {platform.charAt(0).toUpperCase() + platform.slice(1)}
                </a>
              ))}
            </div>
          </div>

          <div className="footer__column">
            <h5 className="footer__heading">Explore</h5>
            <ul className="footer__list">
              {navigation.map(item => (
                <li key={item.path}>
                  <Link to={item.path} className="footer__link">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__column">
            <h5 className="footer__heading">Resources</h5>
            <ul className="footer__list">
              {resourceLinks.map(item => (
                <li key={item.label}>
                  <a href={item.path} className="footer__link">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__column">
            <h5 className="footer__heading">Legal</h5>
            <ul className="footer__list">
              {legalLinks.map(item => (
                <li key={item.label}>
                  <Link to={item.path} className="footer__link">{item.label}</Link>
                </li>
              ))}
            </ul>
            <h5 className="footer__heading footer__heading--mt">Contact</h5>
            <ul className="footer__list">
              <li><span className="footer__link">{company.email}</span></li>
              <li><span className="footer__link">{company.phone}</span></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {currentYear} {company.fullName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
